import { type FlowEndInfo } from "../types";

const DEFAULT_PLACEHOLDER = "You've completed this course. It doesn't end here, let's discover more!";
const PLACEHOLDER_WITH_CONNECTION = "You've completed this course. Continue to the next course now.";

export const getFlowEndMessage = (item?: FlowEndInfo): string => {
  return item?.completedMessage || (item?.nextFlow ? PLACEHOLDER_WITH_CONNECTION : DEFAULT_PLACEHOLDER);
};
